import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { PropType } from 'vue';
import { VueAttributeClass } from '@/types/attributes-vue';

/**
 * TODO: Create alt prop to customize image attribute on different AppIcon instances
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'AppIcon',
  props: {
  src: {
    type: String,
    required: true,
  },
  class: {
    type: [String, Object] as PropType<VueAttributeClass>,
    default: 'h-[24px]',
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    role: "presentation",
    src: props.src,
    alt: "Icon",
    class: _normalizeClass([props.class, "object-contain"])
  }, null, 10, _hoisted_1))
}
}

})